import styled from "styled-components"
import {Hr} from "@irati/ui/src/Layout"

export const CardsContainer = styled.div`
  height: auto;
  width: 460px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  flex-direction: column;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    width: 100%;
  `}
`

export const StyledHr = styled(Hr)`
  width: 100% !important;
  margin: 0 !important;
`

export const ContainerShadow = styled.div`
  width: 100%;
  height: 35px;
  background-color: ${({theme}) => theme.colors.greys.white};
  position: absolute;
  filter: blur(10px);
  bottom: -10px;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    display: none;
  `}
`

export const CardsWrapper = styled.div`
  width: 100%;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    height: calc(100vh - 50px);
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    max-height: 560px;
  `}
`

export const EmptyContainer = styled.div`
  width: 420px;
  height: 560px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    width: 100%;
    height: calc(100vh - 50px);
  `}
`

export const ExternalBorder = styled.div`
  width: 194px;
  height: 195px;
  border: 1px solid #c9cfd0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.utility.highlight};
  width: 166px;
  height: 166px;
  border-radius: 50%;
`
